import PropTypes from 'prop-types';

import {
  FilterContainer,
  IconStyled,
  LabelStyled,
} from './TrlSimpleFilter.styles';

export const TrlSimpleFilter = ({
  value,
  icon,
  label,
  isSelected,
  onClick,
}) => (
  <FilterContainer id={value} onClick={onClick}>
    <IconStyled icon={icon} isSelected={isSelected} />
    <LabelStyled isSelected={isSelected}>{label}</LabelStyled>
  </FilterContainer>
);

TrlSimpleFilter.propTypes = {
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
};
